import { getCurrentTenant } from "@eduviaos/shared";
import { publicApi } from "../api";
import type { SkillCertificateVerify } from "./types";

/**
 * Public credential URL. On per-tenant hosts the slug is already in the
 * subdomain, so the path is `/verify/:code`. In local path-routing the
 * slug has to travel in the URL.
 */
export function certificateVerifyPath(verifyCode: string, fallbackSlug?: string | null): string {
  const encoded = encodeURIComponent(verifyCode);
  if (getCurrentTenant().slug) return `/verify/${encoded}`;
  const slug = fallbackSlug?.trim();
  if (slug) return `/${encodeURIComponent(slug)}/verify/${encoded}`;
  return `/verify/${encoded}`;
}

export async function fetchSkillCertificateVerify(code: string): Promise<SkillCertificateVerify> {
  const res = await publicApi.get<SkillCertificateVerify>(
    `/api/public/skill-certificates/${encodeURIComponent(code)}`,
  );
  return res.data;
}

export function formatCertificateIssuedOn(iso: string, locale: "en" | "hi"): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString(locale === "hi" ? "hi-IN" : "en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
